import Axios from "@/plugins/Axios";

export class EtapasService {
  async getEtapasBimestrais(turmaId) {
    const response = await Axios().get(`gestoes-de-aulas/etapas-bimestrais/${turmaId}`);
    return response.data.etapas;
  }
}
export default new EtapasService();
